export const updateNotificationPermissionsDeployment = (newPermissions, permission) => {
  let allDeploymentsAssigned = permission.assigned;
  let allDeploymentsInEnvAssigned = permission.assigned;

  getDepPermissionsInDomain(newPermissions, permission).forEach(({ environment, assigned }) => {
    if (allDeploymentsAssigned) {
      allDeploymentsAssigned = assigned;
    }
    if (allDeploymentsInEnvAssigned && environment._id === permission.environment._id) {
      allDeploymentsInEnvAssigned = assigned;
    }
  });

  const domainPermissionId = getDomainPermissionId(newPermissions, permission);
  newPermissions[domainPermissionId].assigned = allDeploymentsAssigned;

  const envPermissionId = getEnvPermissionId(newPermissions, permission);
  newPermissions[envPermissionId].assigned = allDeploymentsInEnvAssigned;
};

export const updateNotificationPermissionsEnvironment = (newPermissions, permission) => {
  let allEnvironmentsAssigned = permission.assigned;

  getEnvPermissionsInDomain(newPermissions, permission).forEach(({ _id, environment, deployment, assigned }) => {
    if (allEnvironmentsAssigned && deployment === null) {
      allEnvironmentsAssigned = assigned;
    }
    if (deployment !== null && environment._id === permission.environment._id) {
      newPermissions[_id].assigned = permission.assigned;
    }
  });

  const domainPermissionId = getDomainPermissionId(newPermissions, permission);

  newPermissions[domainPermissionId].assigned = allEnvironmentsAssigned;
};

export const updateNotificationPermissionsDomain = (newPermissions, permission) => {
  getPermissionsInDomain(newPermissions, permission).forEach(({ _id }) => {
    newPermissions[_id].assigned = permission.assigned;
  });
};

const getPermissionsInDomain = (newPermissions, permission) => Object.values(newPermissions).filter(({ name, domain }) => {
  return name === permission.name && domain._id === permission.domain._id;
});

const getDepPermissionsInDomain = (newPermissions, permission) => Object.values(newPermissions).filter(({ name, domain, deployment }) => {
  return name === permission.name && domain._id === permission.domain._id && deployment !== null;
});

const getEnvPermissionsInDomain = (newPermissions, permission) => Object.values(newPermissions).filter(({ name, domain, environment }) => {
  return name === permission.name && domain._id === permission.domain._id && environment !== null;
});

const getDomainPermissionId = (newPermissions, permission) => Object.values(newPermissions).find(({ name, domain, environment, deployment }) => {
  return name === permission.name && domain._id === permission.domain._id && environment === null && deployment === null;
})?._id;

const getEnvPermissionId = (newPermissions, permission) => Object.values(newPermissions).find(({ name, domain, environment, deployment }) => {
  return name === permission.name && domain._id === permission.domain._id && environment !== null && permission.environment !== null && environment._id === permission.environment._id && deployment === null;
})?._id;